import { PartsDTO } from "../models/Parts";
import { setPartCategories } from "../store/slices/Parts/PartsSlice";
import agent from "./agent";
import { ApiFactory } from "./ApiFactory";

export default class PartsApi {

    private apiFactory: ApiFactory;

    constructor(apiFactory: ApiFactory) {
        this.apiFactory = apiFactory;
    }

    getPartCategories = async () => {
        try {
            var value = this.apiFactory.store.getState().reducer.Parts.partCategories;

            if(value.length <= 0) {
                const response = await agent.api.get(`/parts/getPartCategories`, null);
                this.apiFactory.store.dispatch(setPartCategories(response));

                value = this.apiFactory.store.getState().reducer.Parts.partCategories;
            }

            return value;
        }
        catch (error) {
            throw error;
        }
    }

    getParts = async (params: any) => {
        try {
            const response: PartsDTO[] = await agent.api.get(`/parts/getParts`, params);
            return response;
        }
        catch (error) {
            throw error;
        }
    }

}